import { SwapOutlined } from "@ant-design/icons"
import { type CurrencyEnum, PriceIntervalEnum, type Transaction, TransactionTypeEnum } from "@finway-group/shared/lib/models"
import { isSet } from "@finway-group/shared/lib/utils/common"
import moment from "moment"
import React from "react"
import { ExpenseConversionInfo } from "~Components/expenseConversionInfo"
import { PriceLabel } from "~Components/priceLabel"

interface TransactionAmountColumnProps {
    transaction: Transaction
    expenseCurrency?: CurrencyEnum
}

export const TransactionAmountColumn = ({ transaction, expenseCurrency }: TransactionAmountColumnProps) => {
    let transactionSourceRawContent: any = {}
    try {
        transactionSourceRawContent = JSON.parse(`${(transaction as any).sourceRawContent}`)
    } catch (err) {}

    const isPaypalTransaction = isSet(transactionSourceRawContent?.paypalData)
    const isCardTransaction = transaction?.transactionType === TransactionTypeEnum.CARD_TRANSACTION

    const displayConversion =
        expenseCurrency &&
        (expenseCurrency !== transaction?.transactionData?.currency ||
            (isPaypalTransaction && transactionSourceRawContent?.currency && expenseCurrency !== transactionSourceRawContent.currency))

    const cardSourceAmount = transactionSourceRawContent?.sourceAmount
    const paypalSourceAmount = transactionSourceRawContent?.amount
    const sourceAmount = isCardTransaction ? Math.abs(cardSourceAmount) : isPaypalTransaction ? Math.abs(paypalSourceAmount) : undefined

    return (
        <div className="flex align-middle gap-8 justify-start">
            <div className={`flex`}>
                <PriceLabel value={transaction.transactionData.amount} currency={transaction.transactionData.currency} interval={PriceIntervalEnum.ONE_TIME} addPlusSign />
            </div>

            {displayConversion && (
                <>
                    <div className="text-xs opacity-75">
                        <SwapOutlined />
                    </div>
                    <div>
                        <ExpenseConversionInfo
                            className="text-xs pt-2"
                            value={Math.abs(transaction.transactionData.amount)}
                            sourceCurrency={transaction.transactionData.currency}
                            destCurrency={expenseCurrency}
                            showSourceAmount={false}
                            exchangeDate={transaction.transactionData?.date ? moment(transaction.transactionData.date) : undefined}
                            sourceAmount={sourceAmount}
                            size="sm"
                        />
                    </div>
                </>
            )}
        </div>
    )
}
